import Availability from "@dana/Icons/Availability";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { useEffect, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel;
    labelOverride?: string;
    extendedStyles?: ProductCheckAvailabilityLinkStyles;
}

type Props = OwnProps & HasHistory;

export interface ProductCheckAvailabilityLinkStyles {
    link?: LinkPresentationProps;
}

export const productCheckAvailabilityLinkStyles: ProductCheckAvailabilityLinkStyles = {
    link: {
        css: css`
            width: 100%;
        `,
        icon: {
            iconProps: {
                src: Availability,
            },
            position: "left",
        }
    }
};

/**
 * @deprecated Use productCheckAvailabilityLinkStyles instead.
 */
export const productCheckAvailabilityLink = productCheckAvailabilityLinkStyles;

const ProductCheckAvailabilityLink: React.FC<Props> = ({ history, product, labelOverride, extendedStyles, ...otherProps }) => {
    const [styles] = React.useState(() => mergeToNew(productCheckAvailabilityLinkStyles, extendedStyles));
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    const [productDetailsPath, setproductDetailPath] = useState(productDetailPath);
    useEffect(() => {
        if (typeof window !== "undefined") {
            const params = new URLSearchParams(window.location.search);
            const value = (params.get("query") || "").toLowerCase();
            const manufNumber = "product" in product ? product.product.manufacturerItem.toLowerCase() : "";
            const customerProductNumbers = "product" in product ? product.product.customerProductNumber?.toLowerCase().split(",") || [] : "";
            if ((value !== "" && value === manufNumber) || (customerProductNumbers.length > 0 && customerProductNumbers.includes(value))) {
                setproductDetailPath(`${productDetailPath}?criteria=${value}&checkAvilability=${true}`);
            } else {
                setproductDetailPath(`${productDetailPath}?checkAvilability=${true}`);
            }
        }
    }, []);

    return (
        <Link {...styles.link} href={productDetailsPath} {...otherProps} className="btn btn-primary">
            {labelOverride ?? translate("Check Availability")}
        </Link>
    );
};

export default withHistory(ProductCheckAvailabilityLink);
